<template>
    <div>
        <section class="page-title" style="background-color: #00A859">
            <div class="center">
                <h1 class="the-title" style="color: white">Contato</h1>
                <p style="color: white">Dúvidas, críticas ou sugestões entre em contato conosco!</p>
            </div>
        </section>
        <div class="page-content center" style="text-align: center">
            <div class="row-contact">
                <v-flex xs12 sm12 md12 lg6>
                    <v-icon size="50" color="#0098DA">map</v-icon>
                    <p class="title" style="color: #666; margin-top: 10px"><strong>Endereço</strong></p>
                    <p>Av. Tancredo Neves, 620, Salas 1805 e 1806, Empresarial Mundo Plaza, Caminho das Árvores, Salvador - BA, CEP 41820-020</p>
                </v-flex>
                <v-flex xs12 sm12 md12 lg3>
                    <v-icon size="50" color="#0098DA">mail</v-icon>
                    <p class="title" style="color: #666; margin-top: 10px"><strong>E-mail</strong></p>
                    <p>contato@qualidonto.com.br<br>comercial@qualidonto.com.br</p>
                </v-flex>
                <v-flex xs12 sm12 md12 lg3>
                    <v-icon size="50" color="#0098DA">phone</v-icon>
                    <p class="title" style="color: #666; margin-top: 10px"><strong>Central de Atendimento</strong></p>
                    <p>(71) 3276-2562<br>0800 520 0015</p>
                </v-flex>
            </div>
            <!-- <router-link to="/contato" class="button-contact"><i class="far fa-comment-alt"></i>Entre em contato</router-link> -->
        </div>
    </div>
</template>

<script>
  import axios from 'axios'
  import { baseApiUrl } from '@/global'
    export default {
        data() {
            return {

            }
        },
        
        mounted : function() {
            this.verificaVersao()
            this.$store.dispatch('ExibeToolbar')
            this.$store.dispatch('Logar')
        },

        methods : {
          async verificaVersao() {
            await axios.get(`${baseApiUrl}Operadoras/versao`).then(res => {
              if (res.data != null) {
              //console.log("Versão no servidor: ", res.data.versao)
              if (!localStorage.getItem('versao')) {
                //console.log("Sem versão ou com versão: ", localStorage.getItem('versao'))
                localStorage.setItem('versao', res.data.versao)
              } else {
                if (localStorage.getItem('versao') != res.data.versao) {
                  //console.log("Com versão, porem antiga. Alterando...")
                  localStorage.setItem('versao', res.data.versao)
                  window.location.reload(true)
                }
              }
              }
            })
          },
        }

}
</script>

<style>

</style>
